import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2'; // Grid2 (estable en MUI v6)
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';

// Importar todas las imágenes
import voybusLogoBlanco from '../assets/voybus-logo-blanco.svg';
import fbIcon from '../assets/fb.png';
import igIcon from '../assets/ig.png';
import tiktokIcon from '../assets/tiktok.png';
import whatsIcon from '../assets/whats.png';
import visaIcon from '../assets/visa.png';
import masterIcon from '../assets/master.png';
import ocaIcon from '../assets/oca.png';
import passIcon from '../assets/pass.png';
import prexIcon from '../assets/prex.png';
import midiIcon from '../assets/midi.png';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#333',
        color: '#fff',
        pt: 4,
        pb: 4,
      }}
    >
      <Container maxWidth="xl">
        {/* 
          PRIMER BLOQUE: 3 columnas en desktop (size=4 cada una), 
          apiladas en mobile (size=12).
          columns={{ xs: 12, md: 12 }} → 12 columnas disponibles en ambos breakpoints
        */}
        <Grid container spacing={2} columns={{ xs: 12, md: 12 }} sx={{alignItems:"anchor-center"}}>
          {/* Sección 1: LINKS */}
          <Grid
            size={{ xs: 12, md: 4 }}
            sx={{
              // Reordenar: en mobile → 3, en desktop → 1
              order: { xs: 3, md: 1 },
              // Centrar contenido horizontalmente
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center', // Para centrar texto
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link component={RouterLink} to="/quienes-somos" color="inherit" underline="hover">
                Quienes somos
              </Link>
              <Link component={RouterLink} to="/trabaja-con-nosotros" color="inherit" underline="hover">
                Trabaja con nosotros
              </Link>
              <Link component={RouterLink} to="/agencias-promotores" color="inherit" underline="hover">
                Agencias y promotores de viajes
              </Link>
              <Link component={RouterLink} to="/terminos-y-condiciones" color="inherit" underline="hover">
                Términos y condiciones
              </Link>
              <Link component={RouterLink} to="/politicas-privacidad" color="inherit" underline="hover">
                Políticas de privacidad
              </Link>
              <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <Typography variant="body2">MT: 228</Typography>
                <Typography variant="body2">098 88 51 51</Typography>
                <Typography variant="body2">hola@voybus.com</Typography>
              </Box>
            </Box>
          </Grid>

          {/* Sección 2: REDES SOCIALES */}
          <Grid
            size={{ xs: 12, md: 4 }}
            sx={{
              order: { xs: 2, md: 2 },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Typography variant="h6" gutterBottom>
              ¡Seguinos!
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Nuestras redes:
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Box
                component="a"
                href="https://www.facebook.com/profile.php?id=61582334864069&locale=es_LA"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: 'inline-block' }}
              >
                <Box
                  component="img"
                  src={fbIcon}
                  alt="Facebook"
                  sx={{ width: 24, height: 24 }}
                />
              </Box>
              <Box
                component="a"
                href="https://www.instagram.com/voybus.uy/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: 'inline-block' }}
              >
                <Box
                  component="img"
                  src={igIcon}
                  alt="Instagram"
                  sx={{ width: 24, height: 24 }}
                />
              </Box>
              <Box
                component="img"
                src={tiktokIcon}
                alt="Tiktok"
                sx={{ width: 24, height: 24 }}
              />
              <Box
                component="a"
                href="https://wa.me/59898885151"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: 'inline-block' }}
              >
                <Box
                  component="img"
                  src={whatsIcon}
                  alt="WhatsApp"
                  sx={{ width: 24, height: 24 }}
                />
              </Box>
            </Box>
          </Grid>

          {/* Sección 3: LOGO VOYBUS */}
          <Grid
            size={{ xs: 12, md: 4 }}
            sx={{
              order: { xs: 1, md: 3 },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Box
              component="img"
              src={voybusLogoBlanco}
              alt="Voybus"
              sx={{ maxHeight: 60 }}
            />
          </Grid>
        </Grid>

        {/* SEGUNDO BLOQUE: Medios de pago (fila completa) */}
        <Grid container spacing={2} columns={{ xs: 12, md: 12 }} sx={{ mt: 3 }}>
          <Grid
            size={{ xs: 12 }}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 2,
                justifyContent: 'center',
              }}
            >
              <Box
                component="img"
                src={visaIcon}
                alt="Visa"
                sx={{ height: 30 }}
              />
              <Box
                component="img"
                src={masterIcon}
                alt="MasterCard"
                sx={{ height: 30 }}
              />
              <Box
                component="img"
                src={ocaIcon}
                alt="OCA"
                sx={{ height: 30 }}
              />
              <Box
                component="img"
                src={passIcon}
                alt="PassCard"
                sx={{ height: 30 }}
              />
              <Box
                component="img"
                src={prexIcon}
                alt="Prex"
                sx={{ height: 30 }}
              />
              <Box
                component="img"
                src={midiIcon}
                alt="MiDinero"
                sx={{ height: 30 }}
              />
              
            </Box>
          </Grid>
        </Grid>

        {/* TERCER BLOQUE: Derechos reservados */}
        <Grid container spacing={2} columns={{ xs: 12, md: 12 }} sx={{ mt: 3 }}>
          <Grid
            size={{ xs: 12 }}
            sx={{
              textAlign: 'center',
            }}
          >
            <Typography variant="body2" align="center">
              © 2026 Voybus - AMERICA EN BUS S.R.L. | Todos los derechos reservados.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Footer;
